module.exports = __webpack_public_path__ + "static/media/btn-create-chat.92ecb896.svg";